import { useEffect, useMemo } from "react";
import useApplicationStore from "../../../state/ApplicationStore";
import { Fieldset, FormGroup } from "frno-react";
import useTextStore from "../../../state/TextStore";

type InvestmentReturnFilterProps = {
  idPrefix: "mobile-" | "desktop-";
};
export default function InvestmentReturnFilter({
  idPrefix,
}: InvestmentReturnFilterProps) {
  const returnPeriodOptions = useMemo(() => ["3", "5", "7", "10"], []);

  const { getTextByKey } = useTextStore();

  const { selectedReturnPeriod, setSelectedReturnPeriod } =
    useApplicationStore();

  const options = returnPeriodOptions.map((returnPeriod) => ({
    label: getTextByKey(`filter.return.option.${returnPeriod}`),
    value: returnPeriod,
  }));

  useEffect(() => {
    if (!selectedReturnPeriod) setSelectedReturnPeriod(returnPeriodOptions[1]);
  }, [returnPeriodOptions]);

  const handleOptionChange = (value: string) => {
    setSelectedReturnPeriod(value);
  };

  return (
    <Fieldset legend={getTextByKey("filter.return.header")} className="mt-8">
      <FormGroup
        id={idPrefix}
        type={"radio"}
        value={selectedReturnPeriod}
        options={options}
        onChange={(e) => handleOptionChange(e.target.value)}
      />
    </Fieldset>
  );
}
